<template>
    <div class="biz-faq">
        <div class="biz-faq-wrap" v-bind:style="{'min-height': myHeight}">
            <div class="biz-faq-header">
                <div class="tool-bar-mask"></div>
                <h1 class="biz-faq-header-title">常見問題</h1>
                <table-search @changeWord="setFilterWord" :setDefault="filterWordIsEmpty"></table-search>
                <div class="main-list">
                    <div class="main-list-title">問題分類</div>
                    <ul>
                        <li class="list active" @click="clickEvent" :data-id="null">全部</li>
                        <li class="list" @click="clickEvent" v-for="(category, index) in categoryList" :key="index" :data-id="index">
                            {{category.categoryName}}
                        </li>
                    </ul>
                </div>
            </div>
            
            <!-- 搜尋結果 -->
            <div class="biz-faq-body" v-if="filterWord">
                <span class="result">“ {{filterWord}} ” 搜尋結果</span>
                <faq-block  :isClose="true"  v-for="(list, index) in listItem" :key="index">
                    <div slot="faq-title">
                        <text-highlight :queries="queries">
                         {{list.question}}
                     </text-highlight>
                    </div>
                    <div slot="faq-body">
                        <div v-html="list.answer"></div><br>
                        <iframe v-if="list.videoLink" width="560" height="315" :src="list.videoLink" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                    </div>
                </faq-block>
            </div>
            <!-- 無結果 -->
            <div class="biz-faq-body" v-if="filterEmpty">
                <div class="filter-empty">
                    <span>0 個搜尋結果</span>
                    <button class="default-button"  @click="setFilterDefault">清除篩選</button>
                </div>
            </div>
            <!-- 全部結果 -->
            <div class="biz-faq-body" v-if="selectedId != null && !filterWord">
                <div class="questions-block" >
                    <div class="questions-block-title">{{filterResult.categoryName}}</div>
                    <div class="questions-wrap">
                        <faq-block :isClose="true" v-for="(list, index2) in filterResult.managementFaqList" :key="index2">
                            <div class="faq-title" slot="faq-title">
                                {{list.question}}
                            </div>
                            <div class="faq-body" slot="faq-body">
                                <div v-html="list.answer"></div><br>
                                <iframe v-if="list.videoLink" width="560" height="315" :src="list.videoLink" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                            </div>
                        </faq-block>
                    </div>
                </div>
            </div>
            <!-- 選擇分類結果 -->
            <div class="biz-faq-body" v-else-if="selectedId == null && !filterWord">
                <div class="questions-block"  v-for="(category, index) in filterResult" :key="index" :data-id="index">
                    <div class="questions-block-title">{{category.categoryName}}</div>
                    <div class="questions-wrap">
                        <faq-block :isClose="true" v-for="(list, index2) in category.managementFaqList" :key="index2">
                            <div class="faq-title" slot="faq-title">
                                {{list.question}}
                            </div>
                            <div class="faq-body" slot="faq-body">
                                <div v-html="list.answer"></div><br>
                                <iframe v-if="list.videoLink" width="560" height="315" :src="list.videoLink" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                            </div>
                        </faq-block>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import FaqBlock from '@/components/landlord/faq/FaqBlock.vue';
import TableSearch from '@/components/widge/TableSearch.vue';
import { 
    apiBizFaqList,
    } from "@/apis/api.js"; 

export default {
    data() {
        return {
            faqList: [],
            categories: [],
            selectedId: null,
            filterEmpty: false,
            filterWord: '',
            filterWordIsEmpty: false,
            listItem: [],
            listIsFixed: false,
            queries: [],
            myHeight: (window.innerHeight) + 'px'
        }
    },
    mounted () {
        this.$analytics.logEvent("常見問題", {
            screen_name: "常見問題"
        });
        window.addEventListener('scroll', this.handleScroll);
        this.gerFaqList()
    },
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll);
        document.getElementsByClassName('tool-bar-wrap')[0].style.display = 'flex'
    },
    watch: {
        filterWord: function (val) {
            this.listItem = []
            this.queries[0] = val
            if( this.selectedId == null){
                this.filterByState.filter((category) => {
                    if( this.filterWord ){
                        category.managementFaqList.filter((list) => {
                            if(list.answer.includes(this.filterWord) || list.question.includes(this.filterWord)){
                                this.listItem.push(list)
                            }
                        })
                    }
                });
            }else{
                this.filterByState.managementFaqList.filter((list) => {
                    if(list.answer.includes(this.filterWord)){
                        this.listItem.push(list)
                    }
                })
            }
            if(this.listItem.length == 0 && this.filterWord){
                this.filterEmpty = true
            }else{
                this.filterEmpty = false
            }
        }
    },
    methods: {
        gerFaqList () {
            apiBizFaqList()
            .then(res => {
                if( res.data.status == "SUCCESS" ){
                    this.faqList = res.data.result
                }
            })
        },
        clickEvent () {
            let e = event
            this.removeActive()
            e.target.setAttribute("class", 'active list');
            this.selectedId = e.target.dataset.id
            // console.log(this.selectedId)
        },
        setFilterWord: function (value) {
            this.filterWordIsEmpty = false
            this.filterWord = value
        },
        setFilterDefault: function () {
            this.filterWord = ''
            this.filterWordIsEmpty = true
            this.selectedId = null
            this.filterEmpty = false
            this.setCatDefault()
        },
        setHightLight: function (val) {
            return val.replace(this.filterWord, '<span class="hight-light>'+this.filterWord+'</span>')
        },
        setCatDefault () {
            this.removeActive()
            // console.log(document.querySelector('.list').setAttribute("class", 'active list'))
            
        },
        removeActive () {
            let catList = document.querySelectorAll('.list')

            for (let i = 0; i < catList.length; i++) {
                const list = catList[i];
                let classVal = list.getAttribute("class").replace("active","")
                list.setAttribute("class",classVal )
            }
        },
        handleScroll: function () {
            let scrollTop = event.target.documentElement.scrollTop
            if( scrollTop >= 81){
                this.listIsFixed = true
            }else{
                this.listIsFixed = false
            }
        },
    },
    computed: {
        categoryList: function () {
            let faqList = this.faqList
            let categoryList = []

            for (let i = 0; i < faqList.length; i++) {
                const element = faqList[i];
                console.log(element)
                categoryList[i] = {
                    categoryCid: element.categoryCid,
                    categoryName: element.categoryName
                }
            }

            return categoryList
        },
        filterByState: function () {
            let faqList = this.faqList
            if( this.selectedId ){
                return faqList[this.selectedId]
            }else{
                return faqList
            }
        },
        filterResult: function () {
            if( this.filterByState.length == 0 ){
                this.filterEmpty = true
            }else{
                this.filterEmpty = false
                return this.filterByState
            }
        },
    },
    components: {
        FaqBlock,
        TableSearch
    },
}
</script>
<style lang="scss" scoped>
    .biz-faq{
        position: relative;
        .biz-faq-wrap{
            position: relative;
            width: 1154px;
            padding: 40px;
            .biz-faq-header{
                margin-bottom: 76px;
                .table-search{
                    position: absolute;
                    right: 40px;
                    top: 33px;
                }
                .biz-faq-header-title{
                    position: relative;
                    font-size: 28px;
                    font-weight: 500;
                    margin-bottom: 30px;
                }
                .main-list{
                    width: 1106px;
                    height: 86px;
                    border-radius: 10px;
                    box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
                    background-color: #ffffff;
                    padding: 20px 24px;
                    .main-list-title{
                        margin-bottom: 20px;
                        font-weight: 500;
                        line-height: 1.29;
                    }
                    >ul{
                        display: flex;
                        align-items: center;
                        li{
                            text-align: center;
                            width: 56px;
                            padding: 8px 16px;
                            border-radius: 4px;
                            border: solid 1px #cacfcd;
                            background-color: #ffffff;
                            color: #a8a5a4;
                            margin-right: 12px;
                            cursor: pointer;
                        }
                        li.active{
                            border: solid 1px #ff9275;
                            color: #ff9275
                        }
                    }
                }
            }
            .biz-faq-header.fixed{
                position: fixed;
                padding-bottom: 36px;
                top: 40px;
                background-color: #f6f6f6;
                z-index: 10;
                .tool-bar-mask{
                    position: fixed;
                    width: 1170px;
                    background-color: #f6f6f6;
                    height: 80px;
                    top: 0px;
                    z-index: 0;
                }
                .biz-faq-header-title{
                    z-index: 1;
                }
                .table-search{
                    top: -10px;
                    margin-left: 925px;
                    z-index: 1;
                    right: unset;
                }
            }
            .biz-faq-body{
                .questions-block{
                    position: relative;
                    margin-bottom: 60px;
                    .questions-block-title{
                        font-size: 20px;
                        font-weight: 500;
                        color: #ff9275;
                        margin-bottom: 20px;
                    }
                }
                .result{
                    display: block;
                    font-size: 20px;
                    font-weight: 500;
                    color: #ff9275;
                    margin-bottom: 20px;
                }
                .filter-empty{
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    flex-direction: column;
                    width: 1154px;
                    height: 160px;
                    border-radius: 8px;
                    border: solid 1px #f0f0f0;
                    background-color: #ffffff;
                    span{
                        display: block;
                        margin-bottom: 20px;
                    }
                    button{
                        width: 200px;
                        padding: 10px 0;
                    }
                }
            }
        }
    }
    @media screen and (max-width: 1280px) {
        .biz-faq{
            .biz-faq-wrap{
                padding: 32px 24px;
                .biz-faq-header{
                    .table-search {
                        top: 24px;
                    }
                    .main-list{
                        width: 1094px;
                    }
                } 
                .biz-faq-header.fixed{
                    .table-search{
                        right: 0px;
                    }
                }
            } 
        } 
        
    }
</style>


// WEBPACK FOOTER //
// src/pages/bussiness/otherPage/faq.vue